import { useState } from "react";
import { SelectedOrder } from "../OrderPage.types";
import { TransactionResponse } from "../PaymentModal/PaymentModal-types";

export function usePaymentFlow(onSuccess: () => void) {
  const [modalPayload, setModalPayload] = useState<SelectedOrder | null>(null);

  const showPayment = (order: SelectedOrder) => {
    setModalPayload(order);
  };

  const closePaymentModal = () => {
    setModalPayload(null);
  };

  const handlePaymentSuccess = (response: TransactionResponse) => {
    onSuccess();
  };

  return {
    modalPayload,
    setModalPayload,
    showPayment,
    closePaymentModal,
    handlePaymentSuccess,
  };
}
